export default function updateEntity(state, action) {
  const { id, updates, entityType } = action

  if (!state.entities[entityType]) return state

  const entity = state.entities[entityType].byId[id]

  if (!entity) return state

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      [entityType]: {
        allIds: state.entities[entityType].allIds,
        byId: {
          ...state.entities[entityType].byId,
          [id]: {
            ...entity,
            ...updates
          }
        }
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateEntity.js